{
  "key": "grevillea-ave-weatherboard",
  "title": "Grevillea Ave weatherboard",
  "suburb": "Kerbside",
  "locationGroup": "backyards",
  "grassType": "couch",
  "cellM": 0.5,
  "w": 30,
  "h": 34,
  "rows": [
    "eeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
    "e.............oobbbbbbbbgggbbe",
    "e.............oobbbbbbbbgggbbe",
    "e.............oogggbbggggggbbe",
    "e.............bbgggggggggggbbe",
    "e.............bbbggggggggggbbe",
    "e.............bbbggggggggggbbe",
    "e.............bbbggggggggggbbe",
    "e.............bbbggggooogggbbe",
    "e.............bbbgggoooooggbbe",
    "e.............bbbggoooooooggge",
    "e.............bbgggoooooooggge",
    "e.............ggggggooooogggge",
    "e.............gggggggoooggggge",
    "egpppppggppbbbggggggggggggggge",
    "egpppppggppgggggggggggggggggge",
    "egpppppggppgggggggggggggggggge",
    "egpppppggppgggggggggggggggggge",
    "egpppppggppggggggoooggggggggge",
    "egpppppggppggggggoooggggggogge",
    "egpppppggppggggggooogggggoogge",
    "egpppppggppgggggggggggggggggge",
    "egpppppggppgggggggggggggggggge",
    "egoooppggppgogggggggggggggggge",
    "pppppppppppppppppppppppppppppp",
    "pppppppppppppppppppppppppppppp",
    "gggggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggggg",
    "gggggggggggggggggggggggggggggg",
    "pppppppppppppppppppppppppppppp",
    "..............................",
    "..............................",
    ".............................."
  ],
  "zoneRows": [
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "..............................",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "..............................",
    "..............................",
    "..............................",
    ".............................."
  ],
  "zones": [
    {"id":"nature-strip","rangeMm":[50,70]}
  ],
  "rangeMm": [35,50],
  "startLengthMm": [70,110],
  "props": [
    {"id":"house","kind":"house","x":3.75,"y":3.75,"w":6.5,"h":6.5,"solid":true,"penalty":false},
    {"id":"water-tank-1","kind":"water-tank","x":7.5,"y":1.1,"r":0.7,"solid":true},
    {"id":"trampoline-1","kind":"trampoline","x":11.25,"y":5.5,"r":1.6,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":13.1,"y":10.1,"r":0.4,"solid":true,"canopyR":3.2},
    {"id":"sandpit-1","kind":"sandpit","x":9.1,"y":9.9,"w":1.4,"h":1.4,"solid":true},
    {"id":"wheelie-bin-1","kind":"wheelie-bin","x":1.5,"y":11.6,"w":0.6,"h":0.6,"solid":true},
    {"id":"wheelie-bin-2","kind":"wheelie-bin","x":2.25,"y":11.6,"w":0.6,"h":0.6,"solid":true},
    {"id":"letterbox-1","kind":"letterbox","x":6.25,"y":11.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"tap-1","kind":"tap","x":7.25,"y":7.2,"r":0.1,"solid":false},
    {"id":"garden-hose-1","kind":"garden-hose","x":8.6,"y":7.5,"w":2.5,"h":0.08,"rot":-0.4,"solid":false},
    {"id":"power-pit-1","kind":"power-pit","x":12.25,"y":13.75,"w":0.4,"h":0.4,"solid":false}
  ],
  "spawn": {"x":2.25,"y":11.25,"heading":-1.5707963267948966},
  "utePark": {"x":2.25,"y":12.75,"heading":-1.5707963267948966},
  "weedFraction": 0.1,
  "leaves": {"count":[120,170],"areas":[{"x":10,"y":7,"w":5,"h":5}]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["trampoline","bin-night","magpie-season","sprinkler","lost-ball","hot-day"],
  "slope": {"x":0.06,"y":0}
}
